const config = {
    apiUrl: 'https://app.seaprince.click4demos.co.in'
};

export default config;
